module.exports = __webpack_public_path__ + "static/logo-f682ae5b690e528888ca720d78ae18fd.png";